import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../store/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../api/client/axios';
import { AxiosError } from 'axios';
import { buildListParams } from '../../dataHandlers/queryParams';
import { parseListResponse } from '../../dataHandlers/parseListResponse';

export const fetchCustomers = async (query) => {
  const { data } = await apiClient.get(`/organizations`, { params: query.queryKey[1] });
  return data;
};

export const useGetCustomerHandler = ({ searchQuery = {} } = {}) => {
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const queryClient = useQueryClient();
  const listParams = buildListParams(searchQuery);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery(
    {
      queryKey: ['customers', listParams],
      cacheTime: 0,
      queryFn: fetchCustomers,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: 'always',
    },
    queryClient,
  );

  useEffect(() => {
    if (fetchedData) {
      const { rows, total } = parseListResponse(fetchedData);
      setCustomers(rows);
      setTotalDocuments(total);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (!isError) return;

    if (error instanceof AxiosError) {
      dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      return;
    }

    dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
  }, [dispatch, error, isError]);

  return {
    customers,
    totalDocuments,
    isLoading,
  };
};
